export function webChatReadyStoreMiddleware(callback, delayMS = 400) {
    return () => (next) => (action) => {
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
            setTimeout(() => {
                callback();
            }, delayMS);
        }
        return next(action);
    };
}
//# sourceMappingURL=webChatReadyStoreMiddleware.js.map